var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgYoutube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 24.6,
    height: 24.6,
    rx: 5.8,
    stroke: "#00AAE5",
    strokeWidth: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0924 7.5H8.90762C7.30178 7.5 6 8.94544 6 10.7285V15.2715C6 17.0546 7.30178 18.5 8.90762 18.5H17.0924C18.6982 18.5 20 17.0546 20 15.2715V10.7285C20 8.94544 18.6982 7.5 17.0924 7.5ZM15.126 13.221L11.2977 15.2484C11.1957 15.3024 11.0779 15.2198 11.0779 15.0943V10.9129C11.0779 10.7857 11.1988 10.7032 11.301 10.7607L15.1293 12.9148C15.2431 12.9788 15.2411 13.1601 15.126 13.221Z",
    fill: "#00AAE5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/youtube.23ed2517.svg";
export { ForwardRef as ReactComponent };